"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const __theme_1 = __importDefault(require("./_.theme"));
exports.default = {
    btn: (0, css_1.css)({
        float: 'right',
        margin: '-3px',
    }),
    icon: (0, css_1.css)({
        'fontSize': '22px',
        'color': __theme_1.default.base0B,
        'paddingRight': '10px',
        ':hover': {
            color: __theme_1.default.base0A,
        },
    }),
    hli: (0, css_1.css)({
        color: __theme_1.default.base0D,
        paddingLeft: '25px',
    }),
    hlb: (0, css_1.css)({
        color: __theme_1.default.base09,
        paddingLeft: '10px',
    }),
    heading: (0, css_1.css)({
        fontSize: '14px',
        background: __theme_1.default.base00,
        color: __theme_1.default.base00,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        padding: '14px 0 13px 0',
        margin: 0,
        position: 'absolute',
        width: '100%',
        zIndex: 99,
    }),
};
